import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MapIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2 6.63636V21.1818L8.36364 17.5455L15.6364 21.1818L22 17.5455V3L15.6364 6.63636L8.36364 3L2 6.63636Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M8.36365 3V17.5455"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
    </BaseIcon>
  ),
);

MapIcon.displayName = 'MapIcon';
